import React from 'react'
import { MainUsers } from '../../layouts/MainUsers/MainUsers'

export const Users = () => {
  return (
    <MainUsers />
  )
}
